import React from 'react';
import { Button } from 'antd';
import {
  useCropperModalActions,
  useCropperModalState,
} from '../../../../features/cropperModal';

const CropperFooter = () => {
  const { confirmLoading, inForm } = useCropperModalState();
  const { onCancel, onOk } = useCropperModalActions();
  return (
    <>
      <Button
        onClick={onCancel}
        style={{ marginRight: '8px' }}
        disabled={confirmLoading}
      >
        Отмена
      </Button>
      <Button
        type="primary"
        onClick={onOk}
        loading={confirmLoading}
      >
        {inForm ? 'Ok' : 'Загрузить'}
      </Button>
    </>
  );
};

export default CropperFooter;
